import React, { useEffect, useState } from "react";
import style from "styled-components";
import { FetchAddCart } from "../Actions/cartAction";
import { FetchOneProduct } from "../Actions/productAction";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Container from '../components/Layout/Container/index'
import Button from '../components/Layout/Button/index'
import Title from "../components/Layout/Title";
import Rating from "../components/Layout/Ratings/index";
import Format from "../components/Layout/Format/index";
import Load from "../components/Loading/index";

export const Body = style.div`
    display:flex;
    width:80%;
    margin:2.0rem;
    @media(max-width: 630px) {
    flex-direction: column;
  }
`;

export const BodyContent = style.div`
   display:flex;
   flex-direction:column;
   margin-left:4.0rem;
   width:50%;
    @media(max-width: 630px) {
    width:80%;
    margin:2.0rem;
  }
`;

export const Image = style.img`
        width:50%;
        height:500px;
        @media(max-width: 630px) {
         width:auto;
  }
`;

export const ContentRatings = style.div`
   display:flex;
   margin:2.0rem;
   flex-direction:row;
   gap:1.0rem;
   justify-content:center;
   span{
       font-size:20px;
   }
`;
export const Select = style.select`
   width:50px;
   border:none;
   outline:none;
   &:focus{
       outline:none;
   }
   option{
       font-size:1.0rem;
   }
`;

export default function ProductSingle() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { ProductOne, Loading } = useSelector((state) => state.product);
    const [Qty, setQty] = useState(1);

    useEffect(() => {
        dispatch(FetchOneProduct(id));
    }, [id]);

    const onClick = () => {
        dispatch(FetchAddCart(id, Qty));
    };

    const onChange = (event) => {
        setQty(event.target.value);
    };

    return (
        <Container width={"100%"} type={"row"} justify={"center"} display={"flex"}>
            {!Loading ? (
                <Body>
                    <Image src={ProductOne.image} />
                    <BodyContent>
                        <Title>{ProductOne.title}</Title>
                        <Rating reviews={ProductOne.fav} />
                        <ContentRatings>
                            <Format price={ProductOne.price} />
                            <span>Qty:</span>
                            <Select onChange={onChange} defaultValue={Qty}>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                            </Select>
                        </ContentRatings>
                        <Button color={"rgba(0,230,64,1)"} ty={"submit"} onClick={onClick}>Buy Here</Button>
                    </BodyContent>
                </Body>
            ) : (
                <Load text={"Loading details Product"} />
            )}
        </Container>
    );
}
